import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import DashboardContainer from '../../../../presentation/DashboardContainer';
import layout from './layout.json';

export default class WholesaleDashboardList extends React.Component {
  constructor( props ) {
    super( props );

    this.onRenderData = this.onRenderData.bind( this );
    this.onGridFormatItem = this.onGridFormatItem.bind( this );
  }

  onRenderData( key, data ) {
    if( key === 'Wholesale Alert Values' ){
      return this.onRenderWholesaleAlertValuesData( data );
    } else if( key === 'Wholesale Risk Percentages' ) {
      return this.onRenderWholesaleRiskPercentagesData( data );
    } else if( key === 'Wholesale Total Counts By Hour' ) {
      return this.onRenderWholesaleTotalByHourCountsData( data );
    } else if( key === 'Wholesale Call Counts' ) {
      return this.onRenderWholesaleCallCountsData( data );
    }
    return [];
  }

  onRenderWholesaleAlertValuesData( data ) {

    let result = data[0].map( ( item ) => {

      // Create cvp as percentage
      const cvppercentage = parseFloat( item[ 'CVP' ] );
      const cvppercent = ( cvppercentage.toFixed( 4 ) * 100 );
      item[ 'CVP' ] = cvppercent.toFixed( 0 ).toString() + ' %';

      // Create percent from Percentage
      const percentage = parseFloat( item[ 'PCNT' ] );
      const percent = ( percentage.toFixed( 4 ) * 100 );
      item[ 'PCNT' ] = percent.toFixed( 0 ).toString() + ' %';
      return item;
    } );
    if( data !== undefined ) {
      if( data[0].length > 0 ) {
        return result;
      }
    }
    return [];
  }

  onRenderWholesaleRiskPercentagesData( data ) {
    if( data !== undefined ) {
      if( data[0].length > 0 ) {
        const hours = [ '12A','1A','2A','3A','4A','5A','6A','7A','8A','9A','10A','11A','12P','1P','2P','3P','4P','5P','6P','7P','8P','9P','10P','11P' ];
        let result = data[0].map( ( item ) => {
          item.DATE_OF = item.DATE_OF.toString();

          for( var index = 0;index < hours.length; index++ ) {
            const hour = hours[ index ];
            // Create percent from Percentage
            const percentage = parseFloat( item[ hour ] );
            const percent = ( percentage.toFixed( 4 ) * 100 );
            item[ hour ] = percent.toFixed( 0 ).toString() + ' %';
          }

          if( item.Company.toString().trim() === 'TOTAL' ) {
            item.DATE_OF = '';
            item.DOW = '';
          }

          return item;
        } );
        return result;
      }
    }
    return [];
    //return data[0];
  }

  onRenderWholesaleTotalByHourCountsData( data ) {
    let results = data[0].map( ( item ) => {
      item.DATE_OF = item.DATE_OF.toString();

      if( item.Company.toString().trim() === 'TOTAL' ) {
        item.DATE_OF = '';
        item.DOW = '';
      }
      return item;
    } );
    return results;
  }

  onRenderWholesaleCallCountsData( data ) {
    let result = data[0].map( ( item ) => {
      item.CALL_DATE = item.CALL_DATE.toString();

      // Create percent from Percentage
      const percentage = parseFloat( item[ 'Pcnt_Pace' ] );
      const percent = ( percentage.toFixed( 4 ) * 100 );
      item[ 'Pcnt_Pace' ] = percent.toFixed( 1 ).toString() + ' %';

      // If Totals row then blank out fields for grid.
      if( item.CLIENT.toString().trim() === 'TOTALS' ) {
        item.CALL_DATE = '';
        item.DOW = '';
        item.HOD = '';
        item.WEEKS = '';
      }
      return item;
    } );

    if( data !== undefined ) {
      if( data[0].length > 0 ) {
        return result;
      }
    }
    return [];
  }

  

  onGridFormatItem( key, panel, e ) {

    if( key === 'Wholesale Alert Values' ) {
      return this.onGridFormatItemWholesaleAlertValues( panel, e );
    }
    if( key === 'Wholesale Risk Percentages' ) {
      return this.onGridFormatItemWholesaleRiskPercentages( panel, e );
    }

    if( key === 'Wholesale Total Counts By Hour' ) {
      return this.onGridFormatItemWholesaleTotalCountsByHour( panel, e );
    }

    if( key === 'Wholesale Call Counts' ) {
      return this.onGridFormatItemWholesaleCallCounts( panel, e );
    }
  }

  onGridFormatItemWholesaleAlertValues( panel, e ) {
 
  }

  onGridFormatItemWholesaleRiskPercentages( panel, e ) {

  }

  onGridFormatItemWholesaleTotalCountsByHour( panel, e ) {
  
  }

  onGridFormatItemWholesaleCallCounts( panel, e ) {
    
  }

  render( ) {
    return (
      <PageAuthorize groups={['Administrators','Operations','Management','Dashboards']} >
        <DashboardContainer layout={layout} onRenderData={this.onRenderData} onGridFormatItem={this.onGridFormatItem} />
      </PageAuthorize>
    );
  }
}



// WEBPACK FOOTER //
// ./src/content/dashboards/wholesale/components/WholesaleDashboardList.js